// extracted by mini-css-extract-plugin
module.exports = {"AccountLogo":"AccountLogo_AccountLogo__SKbek"};